import React from 'react';
import Hero from '../components/Hero';
import Industries from '../components/Industries';
import ProductSpotlight from '../components/ProductSpotlight';
import Services from '../components/Services';
import InstitutionGrid from '../components/InstitutionGrid';
import JsonLd from '../components/JsonLd';
import { organizationSchema, websiteSchema, faqSchema } from '../utils/schema';
import { faqs } from '../data/site';
import FeaturedWork from '../components/FeaturedWork';
import AuditPromo from '../components/AuditPromo';
import Stats from '../components/Stats';
import Process from '../components/Process';
import Team from '../components/Team';
import FAQ from '../components/FAQ';
import LatestPosts from '../components/LatestPosts';
import CtaBand from '../components/CtaBand';
import usePageMeta from '../utils/usePageMeta';

const Home = () => {
  usePageMeta(null, 'School website design, school ERP, coaching institute marketing, social media, content writing and career counselling for schools, colleges and institutes in Delhi NCR and across India.');

  return (
    <>
      <JsonLd data={[organizationSchema(), websiteSchema(), faqSchema(faqs)]} />
      <Hero />
      <Industries />
      <Services />
      <InstitutionGrid alt />
      <ProductSpotlight showFeatures={false} />
      <FeaturedWork />
      <AuditPromo />
      <Stats />
      <Process alt={false} />
      <Team />
      <LatestPosts />
      <FAQ alt />
      <CtaBand />
    </>
  );
};

export default Home;
